import react from 'react'
import { Controller, Control, FieldError } from 'react-hook-form'
import { TextField, TextFieldProps } from '@mui/material'

type ControlledTextFieldProps = {
  name: string;
  control: Control<any>;
  error?: FieldError;
} & Omit<TextFieldProps, 'error'>

const ControlledTextField: react.FC<ControlledTextFieldProps> = ({
  name,
  control,
  error,
  ...rest
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { value, onChange, onBlur } }) => (
      <TextField
        data-testid={name}
        fullWidth
        error={Boolean(error)}
        helperText={error?.message}
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        {...rest}/>
    )} />
)

export default ControlledTextField
